import { accessControlsConstants, keyManageConstants } from "../_constants";

export function activation(state = {}, action) {
  switch (action.type) {
    case accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_REQUEST:
    case keyManageConstants.DEACTIVATE_API_KEY_REQUEST:
    case keyManageConstants.ACTIVATE_API_KEY_REQUEST:
      return { loading: true };

    case accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_SUCCESS:
    case accessControlsConstants.ACCESS_CONTROLS_ROLE_ACTIVATE_FAILURE:
    case keyManageConstants.DEACTIVATE_API_KEY_SUCCESS:
    case keyManageConstants.DEACTIVATE_API_KEY_FAILURE:
    case keyManageConstants.ACTIVATE_API_KEY_SUCCESS:
    case keyManageConstants.ACTIVATE_API_KEY_FAILURE:
      return { reload: true };
    default:
      return state;
  }
}
